import { ReactElement } from 'react'

import { ImportedInvoiceDrawerProvider } from '@features/importedInvoices/context/importedInvoiceDrawer'
import { ImportedInvoiceDrawer } from '@features/importedInvoices/elements/ImportedInvoiceDrawer'

import { ImportedInvoicesListDataProvider } from './context/importedInvoicesListData'
import { ImportedInvoicesListFiltersProvider } from './context/importedInvoicesListFilters'
import { ImportedInvoicesListContent } from './ImportedInvoicesListContent'

export const ImportedInvoicesList = (): ReactElement => {
  return (
    <ImportedInvoiceDrawerProvider>
      <ImportedInvoicesListFiltersProvider>
        <ImportedInvoicesListDataProvider>
          <ImportedInvoicesListContent />
          {/* A sibling of the content, not a child: the content early-returns the processing and
              empty screens, which would suppress the drawer on load and flash it closed on a refresh. */}
          <ImportedInvoiceDrawer />
        </ImportedInvoicesListDataProvider>
      </ImportedInvoicesListFiltersProvider>
    </ImportedInvoiceDrawerProvider>
  )
}
